import type { SVGProps } from 'react';

const SvgCheckMark = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <g fill={props.color} data-name="checkmark">
      <path d="m9 13.13-1.1 1.06L13.75 20a.8.8 0 0 0 .53.22.74.74 0 0 0 .53-.22L31.62 3.29l-1.05-1.06-16.29 16.22Z" />
      <path d="M14.39 30a13.93 13.93 0 0 0 13.55-17l-1.47.33a12.2 12.2 0 0 1 .31 2.76 12.38 12.38 0 1 1-5.44-10.24l.84-1.24A13.9 13.9 0 1 0 14.39 30" />
    </g>
  </svg>
);

export default SvgCheckMark;
